<template>
  <v-app id="app">
    <LoadingOverlayCircular v-if="isLoadingCircular"></LoadingOverlayCircular>

    <!-- ヘッダー -->
    <Header v-if="isShowHeader" :brand="brand" />

    <!-- コンテンツ -->
    <v-content id="top_card" class="content">
      <CommonMessage />
      <BackTopButton />
      <transition name="router-transition">
        <router-view></router-view>
      </transition>
    </v-content>
    <!-- フッター -->
    <Footer v-if="isLoginPage || isDefaultPage" />
  </v-app>
</template>

<script>
import 'normalize.css';
import BackTopButton from '@/components/_atoms/buttons/BackTopButton.vue';
import LoadingOverlayCircular from '@/components/_atoms/loadings/LoadingOverlayCircular.vue';
import CommonMessage from '@/components/_organisms/CommonMessage.vue';
import Header from '@/components/_organisms/Header.vue';
import Footer from '@/components/_organisms/Footer.vue';
import Brand, { getBrandByKey } from '@/constants/brand/brand';

export default {
  name: 'App',
  data() {
    return {
      brand: Brand.Lecheck
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.state.auth.isLoggedIn;
    },
    isLoginPage: function () {
      return this.$route.name === 'Login' || this.$route.name === 'LoginForCloudsignReview';
    },
    isShowHeader: function () {
      return this.$route.name === 'LoginForLeFILING' || (this.$store.state.showHeader.isShowHeader && this.$store.state.auth.userId);
    },
    isDefaultPage: function () {
      return this.$route.name === 'PageNotFound';
    },
    isLoadingCircular: function () {
      return this.$store.state.loading.isLoadingCircular;
    },
    isSalesforceUserLinked: function () {
      return this.$store.state.auth.profile.isSalesforceUserLinked;
    },
    canUseChatBot: function () {
      return this.$store.state.auth.profile.canUseChatBot;
    },
    isShowChat: function () {
      return this.isLoggedIn && this.isSalesforceUserLinked && this.canUseChatBot;
    }
  },
  beforeCreate() {
    this.$store.dispatch('userAgent/setData');
  },
  mounted() {
    // localStorageに保存されているブランドキーを取得（userInfoを待つと時間がかかるので）
    this.updateBrandSetting();
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'auth/setUserInfo') {
        this.updateBrandSetting();
      }
    });
  },
  components: {
    CommonMessage,
    LoadingOverlayCircular,
    BackTopButton,
    Header,
    Footer
  },
  methods: {
    updateBrandSetting() {
      const brandKey = this.$store.state.auth.brandKey;
      const localStorageBrand = localStorage.getItem('brandKey');
      if (brandKey) {
        this.brand = getBrandByKey(brandKey);
      } else if (localStorageBrand) {
        this.brand = getBrandByKey(localStorageBrand);
      } else {
        // 変更なし
        return;
      }
      document.title = this.brand.title;
      document.getElementById('favicon').href = this.brand.faviconFileName;
    }
  }
};
</script>

<style scoped>
.content {
  background: #edebe6;
  margin-top: 50px;
}
.progresbar {
  z-index: 130;
}
.app__circular {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1000;
}
.overlay--active::before {
  opacity: 0.46;
  background-color: #212121;
  content: '';
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  -webkit-transition: inherit;
  transition: inherit;
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
  z-index: 900;
}
</style>
